<template>
  <div class="container text-center">
    <section class="card-selection-wrapper">
      <div class="head-title pb-0">
        <h2 class="text-uppercase text-black">Discover</h2>
      </div>
      <div class="row mt-2 no-gutters align-item-center justify-content-center">
        <div class="col-md-4">
          <div class="card">
            <div class="card-body mb-0 pb-0" v-if="!selectedCaptain">
              <a href="JavaScript:void(0)" @click="showSelection('captain')">
                <i class="fal fa-plus"></i>
              </a>
              <h1 class="card-text mb-0">Choose</h1>
              <h4 class="text-uppercase">your captain</h4>
            </div>
            <div class="card-body" v-if="selectedCaptain">
              <img
                class="card-img-top"
                :src="getImgUrl(selectedCaptain.img)"
                alt=""
                @click.prevent="showSelection('captain')"
              />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body" v-if="selectedShip">
              <img
                class="card-img-top"
                :src="getImgUrl(selectedShip.img)"
                alt=""
                @click.prevent="showSelection('ship')"
              />
            </div>
            <div class="card-body pb-0" v-if="!selectedShip">
              <a href="JavaScript:void(0)" @click="showSelection('ship')">
                <i class="fal fa-plus"></i>
              </a>
              <h1 class="card-text mb-0">Choose</h1>
              <h4 class="text-uppercase font-weight-bold">your ship</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="my-2">
        <button class="btn btn-outline font-weight-bold">Supplies</button>
      </div>
      <div
        class="d-flex justify-content-center align-items-center card-container"
      >
        <template
          v-if="
            !selectedFoods || selectedLocation.req_food > selectedFoods.length
          "
        >
          <div class="card-1" v-if="!isLoaded">
            <div class="card-body h-100 justify-content-between">
              <a href="JavaScript:void(0)" @click="showSelection('food')">
                <i class="fal fa-plus mt-3"></i>
              </a>
              <h4 class="card-text mb-0">Food</h4>
              <p class="req-food">
                Required {{ selectedLocation.req_food || 1 }}
              </p>
            </div>
          </div>
        </template>
        <template v-if="selectedFoods">
          <div class="card-1" v-for="(item, i) in selectedFoods" :key="i">
            <div class="card-body">
              <img
                class="card-img-top"
                :src="getImgUrl(item.img)"
                alt=""
                @click.prevent="showSelection('food')"
              />
            </div>
          </div>
        </template>
        <div class="card-1">
          <div
            class="card-body h-100 justify-content-between"
            v-if="!selectedSupply"
          >
            <a href="JavaScript:void(0)" @click="showSelection('supplies')">
              <i class="fal fa-plus mt-3"></i>
            </a>
            <h4 class="card-text mb-0">Supply</h4>
            <p class="req-food">Required 1</p>
          </div>
          <div class="card-body" v-if="selectedSupply">
            <img
              class="card-img-top"
              :src="getImgUrl(selectedSupply.img)"
              alt=""
              @click.prevent="showSelection('supplies')"
            />
          </div>
        </div>
      </div>
    </section>
    <ShipInfoModal
      :error="error"
      v-if="showModal"
      :cards="info"
      :cardName="card"
      :req_food="selectedLocation.req_food"
      :selectedLocation="selectedLocation"
      v-on:w-modal-hide-click="showModal = false"
    />
    <footer class="d-flex justify-content-between align-items-center container">
      <div class="back-btn">
        <router-link to="/continent">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </router-link>
      </div>
      <div class="select-btn">
        <a href="JavaScript:void(0)" class="btn" @click.prevent="attack()">
          <span class="d-block text-black p-0 m-0"></span>
          Attack
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
import ShipInfoModal from "../components/ShipInfoModal.vue";
import ApiService from "../services";
import { mapGetters } from "vuex";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "Discover",
  computed: {
    ...mapGetters([
      "selectedCaptain",
      "selectedShip",
      "selectedFoods",
      "selectedSupply",
      "attackData",
    ]),
  },
  data() {
    return {
      showModal: false,
      card: null,
      foodRequired: 1,
      Loading: true,
      selectedLocation: { req_food: 1 },
      location: "Europe",
    };
  },
  components: {
    ShipInfoModal,
  },
  mounted() {
    this.location = localStorage.getItem("location");
    if (!this.location) {
      toast.error("please select location first. redirecting");
      setTimeout(() => {
        this.$router.push("dashboard");
      }, 1000);
    }
    this.Loading = true;
    ApiService.getTable(
      "distance",
      null,
      async (result) => {
        if (result.rows.length > 0) {
          this.info = result.rows;
          this.selectedLocation = this.info.filter(
            (el) => el.location == this.location
          )[0];
          this.Loading = false;
        }
      },
      (error) => {
        this.Loading = false;
        toast.error(error);
      }
    );
  },
  methods: {
    showSelection(option) {
      this.card = option;
      this.showModal = true;
    },
    getImgUrl(hash) {
      let url = "http://ipfs.io/ipfs/" + hash;
      return "//lostsailor/images.weserv.nl/?url=" + url + "&w=500";
    },
    async attack() {
      if (this.attackData.length < 4) {
        toast.error(
          "Missing cards, you need foods,supply,captain and a ship to attack."
        );
        return;
      }
      const data = {
        from: localStorage.getItem("wax_user"),
        to: process.env.VUE_APP_CONTRACT,
        asset_ids: this.attackData,
        memo: `attack:${this.location}`,
      };
      await ApiService.attack(
        data,
        (res) => {
          if (res.processed) {
            toast.success("Attack has been made, redirecting...");
            setTimeout(() => {
              this.$router.push("waiting");
            }, 2000);
          }
        },
        (error) => {
          this.error = ApiService.errorFormat(error);
          toast.error(this.error);
        }
      );
    },
  },
};
</script>

<style>
.discover-section .back-btn {
  margin-top: -20px !important;
  /* margin-bottom: 10px; */
  float: left;
}
.req-food {
  color: #990d2c;
  font-size: 10px;
  margin-bottom: 0;
  font-weight: 600;
}

footer {
  position: fixed;
  bottom: 40px;

  left: 0;
  right: 0;
}
</style>